<template>
    <div class="d-flex  justify-content-between">
        <div>
            <BPagination
                    :per-page.sync="pageSize"
                    :total-rows.sync="totalCount"
                    :value.sync="page"
                    @change="$emit('update:page', $event)"
                    aria-controls="table"
            >
                <template v-slot:index>{{page}}
                </template>
            </BPagination>
        </div>
        <div>
            <ul class="pagination b-pagination">
                <li class="page-item disabled">
                    <span class="page-link">Page {{page}} of {{Math.ceil(totalCount / pageSize)}} ({{totalCount}} items)</span>
                </li>
            </ul>
        </div>
        <div class="page-size-container ">
            Page Size:
            <select
                    :value="pageSize"
                    @change="$emit('update:pageSize', parseInt($event.target.value))"
                    class="form-control form-control-sm"
            >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            page: {
                type: Number,
                required: false,
                default: 1
            },
            pageSize: {
                type: Number,
                required: false,
                default: 10
            },
            totalCount: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped>

    .page-size-container select {
        display: inline-block;
        margin-left: 5px;
        width: inherit;
    }

</style>
